import { RouteType } from "types/RouteType";
import { RootStore } from "@intrasync/stores";
import MMProductionStore from "stores/millermize/MMProductionStore";
import MMLoadStore from "stores/millermize/MMLoadStore";

const loadsRoute: RouteType = {
  name: "MM Loads",
  path: "/mm/loads",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Loads & Delivery",
      component: () => import("./Loads.Header"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./Loads.Body"),
      grayBackground: true,
    },
  },
  group: "Miller-Mize",
  menuOrder: 5,
  requiresAuth: true,
  requiresPermission: false,
  dialogs: [
    {
      name: "Add Load",
      title: "Create New Load",
      component: () => import("./LoadsDialogs/LoadFormDialog"),
    },
    {
      name: "Edit Load",
      title: "Edit Load",
      component: () => import("./LoadsDialogs/LoadFormDialog"),
    },
    {
      name: "Manage Pallets",
      title: "Manage Pallets",
      component: () => import("./LoadsDialogs/PalletManagerDialog"),
      // Dialog.Body renders a fixed-height MUI DialogContent and defaults to
      // 400px. This is the largest dialog in the app -- pallets, the free rack
      // and (since item 17) the mark list side by side -- so it was getting the
      // smallest window of any Miller-Mize dialog. Compare 620/640 on the
      // production dialogs.
      height: 720,
    },
    {
      name: "Staged Pallets",
      title: "Staged Pallets",
      component: () => import("./LoadsDialogs/StagedPalletsDialog"),
      height: 720,
    },
  ],
  /**
   * Re-read on entry, and on the header's refresh button (item 18).
   *
   * Creede's "slow refresh": a load marked delivered in one place did not show
   * in another. No mm-* service emits real-time events and each store loaded
   * exactly once per tab, so nothing ever re-read. Coming back to the screen now
   * does.
   *
   * `manualTrigger` is true only for the refresh button (RefreshDataButton calls
   * `triggerEnterSideEffects(true)`), which is what lets a deliberate refresh
   * bypass the throttle that keeps ordinary navigation cheap.
   *
   * Fire-and-forget, and never blocking: the bodies render their own loading
   * state, and a failed re-read must not keep him off the screen. Cast follows
   * the established route-hook pattern -- MM stores are registered dynamically,
   * so RootStore types them loosely.
   */
  beforeEnter: async ({
    rootStore,
    manualTrigger,
  }: {
    rootStore: RootStore;
    manualTrigger?: boolean;
  }) => {
    const production = rootStore.mmProductionStore as
      | MMProductionStore
      | undefined;
    const loads = rootStore.mmLoadStore as MMLoadStore | undefined;
    // Both, on both screens: delivered piece counts are derived from loads and
    // displayed against marks, so reading one without the other is what made
    // the two disagree in the first place.
    void production?.refresh({ force: !!manualTrigger });
    void loads?.refresh({ force: !!manualTrigger });
    return true;
  },
};

export default loadsRoute;
